import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import './filters/filters'
// plugin
import i18n from './plugins/i18n'
import './plugins/vuetify'
import './plugins/vue-cookies'
import './plugins/axios'
import './plugins/moment'
import './plugins/googlemap'
import './plugins/vue-notification'
import './plugins/chartjs'
import './plugins/vue-clipboard'
import './plugins/material-design-icon'
// app included
import './utils/utils'
import './utils/const'
import './store/actionTypes'
import './event-bus'
import AppService from '@/services/app.service'
import AuthenticationModule from '@/modules/authentication'

Vue.config.productionTip = false

// include AppService in all component
Vue.prototype.$appService = AppService
window.vueapp = {
    $vuetify: {
        breakpoint: { name: 'xl' }
    }
}

AuthenticationModule.install(router, store)

window.vueapp = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
